import {EventEmitter, Injectable} from '@angular/core';

import {ConstantsService} from '../../../../services/constants.service';
import {Company, Office, Theme} from '../../../../types/admin-data.types';
import {ApiClientService} from '../../../../services/api-client.service';
import {UrlService} from '../../../../services/url.service';
import {EmptyRowService} from '../../../../services/empty-row.service';
import {AdminService} from '../../../../services/admin.service';
import {Observable} from 'rxjs/Observable';
import {ReplaySubject} from 'rxjs/ReplaySubject';
import {catchError, map, tap} from 'rxjs/operators';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {createInitialNetworkEntity, resolveNetworkEntity} from '../../../../services/helper-functions';
import {Response} from '@angular/http';
import {pipe} from 'rxjs/util/pipe';

declare const toastr: any;
declare const swal: any;
declare const $: any;

@Injectable()
export class ManagementCompanyService {
    spinnerShow = false;

    companies: Company[] = [];
    companiesTotal: number | null = null;

    isShowOfficeModal = false;
    officeInOfficeModal: Office;

    themesList: Array<Theme> = [];

    onToggle: EventEmitter<any> = new EventEmitter();

    companySettings = {
        autoApproveResidentDataChanges: false,
        emailSender: "",
        emailSenderName: "",
        inviteSubject: "",
        inviteTemplate: "",
        signature: "",
        welcomeMessage: ""
    };

    invitationEmailModal: 'invitation'|'reset_password' = null;
    isautoApproveResidentLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    autoApproveResidentLoading = this.isautoApproveResidentLoading.asObservable();

    constructor(public api: ApiClientService,
                public urlService: UrlService,
                public emptyRowService: EmptyRowService,
                private adminService: AdminService) {
        this.getAllThemes();
    }

    /** Companies  */
    getCompanies(checkedId?: number, callback?) {
        return this.getCompaniesByQueryParams(checkedId, callback).subscribe();
    }

    getCompaniesByQueryParams(checkedId?: number, callback?) {
        const queryParams = this.urlService.getQueryParamsString();
        const url = `/api/v1/company.json?expand=offices.members${queryParams}`;
        let dataAdapter;
        if (callback) {
            let calledCallback = false;
            dataAdapter = (item) => {
                const company = new Company(item, checkedId === +item.id);
                if (!calledCallback && item.id === checkedId) {
                    callback(company);
                    calledCallback = true;
                }
                return company;
            };
        } else {
            dataAdapter = item => new Company(item, checkedId === +item.id);
        }

        return this.api.getJson('oauthUrl', url)
            .pipe(
                createInitialNetworkEntity(),
                resolveNetworkEntity(dataAdapter),
                tap(({loading}) => this.spinnerShow = loading),
                tap(
                    body => {
                        this.companies = body.entities;
                        this.companiesTotal = body.total;
                        this.emptyRowService.fillEmptyRow();
                        if ($('.table')[0])
                            $('.table')[0].scrollIntoView();
                    },
                    error => this.api.errorHandler(error, 'Failed get Companies')
                )
            );
    }

    create(data): Observable<any> {
        return this.api.post('oauthUrl', '/api/v1/company.json', data).map((res) => {
            return res;
        }, (error) => {
            this.api.errorHandler(error, 'Create company failed');

            return error;
        });
    }

    view(id) {
        return this.api.get('oauthUrl', `/api/v1/company/${id}.json`).pipe(
            map((response: Response) => response.json()),
            catchError(error =>  {
                this.api.errorHandler(error, 'View company failed');
                return error
            })
        )
    }

    update(id: number, data: any) {
        return this.api.patch('oauthUrl', `/api/v1/company/${id}.json`, data).pipe(
            catchError(error => {
                this.api.errorHandler(error, 'Edit company failed');
                throw error;
            })
        );
    }

    remove(id: number): Observable<any> {
        if (!id) return;

        let subject = new ReplaySubject<any>(null);

        swal(ConstantsService.getSwalConfig('Delete Company'),
            () => {
                const url = `/api/v1/company/${id}`;
                this.api.remove('oauthUrl', url).subscribe(
                    (res) => {
                        toastr.success('Company has been deleted.');
                        this.getCompanies();
                        subject.next(res);
                    },
                    error => this.api.errorHandler(error, 'Delete Company failed')
                );
            }
        );

        return subject;
    }

    toggleCheckCompany(item: Company): boolean {
        const checked = item.checked;
        this.companies.forEach(i => i.checked = false);
        if (!checked)
            item.checked = true;

        this.onToggle.emit();

        return item.checked;
    }

    getAllThemes() {
        this.adminService.getAllThemes().subscribe((res) => {
            this.themesList = res;
        });
        return this.themesList;
    }

    getCompanyTheme(id: number) {
        if (id) {
            return this.themesList.find(item => +item.id === +id);
        } else {
            return new Theme();
        }
    }

    /** Offices  */
    addOffice(data: any): Observable<any> {
        return this.api.post('oauthUrl', '/api/v1/office.json', data).map((res) => res, error => {
                this.api.errorHandler(error, 'Create office failed');

                return error;
            }
        );
    }

    editOffice(officeId: number, data): Observable<any> {
        return this.api.patch('oauthUrl', `/api/v1/office/${officeId}`, data).map((res) => res, error => {
                this.api.errorHandler(error, 'Update office failed');

                return error;
            }
        );
    }

    deleteOffice(office: Office, callback?) {
        swal(ConstantsService.getSwalConfig('Delete Office'),
            () => {
                const url = `/api/v1/office/${office.id}`;
                this.api.remove('oauthUrl', url).subscribe(
                    () => {
                        callback && callback();
                        toastr.success('Office has been deleted.');
                    },
                    error => this.api.errorHandler(error, 'Delete Office failed')
                );
            }
        );
    }

    getCompanySettings(id) {
        this.isautoApproveResidentLoading.next(true)
        this.companySettings.autoApproveResidentDataChanges = false;
        const url = `/v1/company_settings/${id}.json`;
        return this.api.get('domainBD', url).subscribe(
            res => {
                const body = JSON.parse(res._body);
                this.companySettings = {
                    autoApproveResidentDataChanges: body.autoApproveResidentDataChanges,
                    emailSender: body.emailSender,
                    emailSenderName: body.emailSenderName,
                    inviteSubject: body.inviteSubject,
                    inviteTemplate: body.inviteTemplate,
                    signature: body.signature,
                    welcomeMessage: body.welcomeMessage
                };
                this.isautoApproveResidentLoading.next(false)
            },
            error => {
                this.api.errorHandler(error, 'Failed get Companies')
                this.isautoApproveResidentLoading.next(false)
            }
        );
    }

    editCompanySettings(id, value) {
        const data = this.companySettings;
        data.autoApproveResidentDataChanges = value;
        const url = `/v1/company_settings/${id}.json`;
        this.api.patch('domainBD', url, data).subscribe(
            res => {
                toastr.success('Company settings has been changed successfully.');
            }, error => {
                this.api.errorHandler(error, 'Edit company settings failed');
            }
        );
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/admin/management-company/services/management-company.service.ts